import { useContext } from "react";
import { SavedIcon } from "../../../StateManagment/SavedIcon";
import { db } from "../../../firebase/config.js";
import { useFirestore } from "../../../firebase/useFirestore";
import {
    UNREACHABLE_AFTER_DAYS_OPTIONS,
    normalizeUnreachableAfterDays,
} from "../../../helpers/adressHelpers/unreachableAfterDays";

/**
 * Tenantinstelling: hoe lang een huishouden mag lopen voordat het op
 * 'Onbereikbaar' gezet mag worden. Zelfde patroon als DefaultAgendaView.
 */
const UnreachableAfterDays = () => {
    const [, setSaved] = useContext(SavedIcon);
    const compagny = useFirestore("CompagnyMeta");

    /**
     * @param {string} docid - CompagnyMeta-document van deze tenant
     * @param {string} value - Gekozen aantal dagen, als string uit de <select>
     */
    const periodHandler = (docid, value) => {
        db.collection("CompagnyMeta")
        .doc(docid)
        .update({
            // Als getal wegschrijven, niet als string: de knop rekent ermee.
            UnreachableAfterDays: Number(value)
        })
        .then(() => {
            setSaved('flex');
        });
    };

    return (
        <div className="dashboard-container">
            <h2>Wachttijd voor 'Onbereikbaar'</h2>
            <p>
                Kies hoe lang er geprobeerd moet zijn voordat een huishouden op 'Onbereikbaar' gezet kan worden.
                De knop verschijnt pas na drie mislukte pogingen op rij én zodra deze periode is verstreken,
                geteld vanaf de eerste mislukte poging.
            </p>
            {compagny && compagny.map((comp) => (
                <div key={comp.ID} className="settings-general-module-settings-item-container">
                    <p>Wachttijd</p>
                    <select
                        value={normalizeUnreachableAfterDays(comp.UnreachableAfterDays)}
                        onChange={(e) => periodHandler(comp.docid, e.target.value)}
                    >
                        {UNREACHABLE_AFTER_DAYS_OPTIONS.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                </div>
            ))}
        </div>
    );
};

export default UnreachableAfterDays;
